import { HStack, Box } from "@chakra-ui/react";
import { MdStar, MdStarBorder } from "react-icons/md";

interface StarRatingProps {
  rating?: number;
  onChange?: (rating: number) => void;
  size?: number;
  interactive?: boolean;
}

export default function StarRating({ rating = 0, onChange, size = 20, interactive = false }: StarRatingProps) {
  const stars = [1, 2, 3, 4, 5];
  // Ensure rating is within bounds and is an integer
  const validRating = Math.max(0, Math.min(5, Math.floor(rating || 0)));

  const handleClick = (star: number) => {
    if (interactive && onChange) {
      onChange(star);
    }
  };

  return (
    <HStack gap={0.5}>
      {stars.map((star) => {
        const isFilled = star <= validRating;
        return (
          <Box
            key={star}
            onClick={() => handleClick(star)}
            cursor={interactive ? "pointer" : "default"}
            color={isFilled ? "accent.default" : "text.subtle"}
            transition="all 0.2s"
            _hover={interactive ? { transform: "scale(1.1)", color: isFilled ? "accent.emphasis" : "text.muted" } : {}}
          >
            {isFilled ? <MdStar size={size} /> : <MdStarBorder size={size} />}
          </Box>
        );
      })}
    </HStack>
  );
}
